import styled from "styled-components";
import { typographyMixin } from "../../typography";
import { BreakPoints } from "../../constants";
import { lighten } from "polished";

type props = {
  alterDateColor: boolean;
};

export const StyledRecentGame = styled.div.attrs({
  className: "recentgame",
})<{ enableLinks: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-width: 1fr;
  height: 100%;
  ${typographyMixin}

  cursor: ${(props) => (props.enableLinks ? "pointer" : "default")};

  &:hover {
    background: ${(props) => props.enableLinks && "rgba(55, 56, 61, 0.2)"} !important;
  }
`;

export const DateContainer = styled.div.attrs({
  className: "recentgame-date-container",
})<props>`
  display: flex;
  flex-direction: column-reverse;
  align-items: center;
  text-transform: uppercase;
  writing-mode: vertical-rl;
  text-orientation: upright;
  letter-spacing: -2px;
  padding: 0.5rem;
  font-size: 14px;
  background-color: ${(props) => (props.alterDateColor ? lighten(0.1, props.theme.secondaryColor) : props.theme.secondaryColor)};
  color: ${(props) => props.theme.textOnSecondaryColor};
`;

export const Date = styled.div.attrs({
  className: "recentgame-date",
})``;

export const Title = styled.div.attrs({
  className: "recentgame-title",
})`
  flex: 2;
  text-align: center;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: uppercase;

  @media only screen and (max-width: ${BreakPoints.md}) {
    font-size: 16px;
  }
  @media only screen and (max-width: ${BreakPoints.sm}) {
    font-size: 14px;
  }
`;

export const LogoContainer = styled.div.attrs({
  className: "recentgame-logo-container",
})`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 1;
  padding-left: 1rem;
`;

export const Logo = styled.img.attrs({
  className: "recentgame-logo",
})`
  object-fit: contain;
  max-width: 50px;
  max-height: 50px;
`;

export const Result = styled.div.attrs({
  className: "recentgame-result",
})`
  flex: 1;
  text-align: center;
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  text-transform: uppercase;
`;

export const StyledRecentGameList = styled.div.attrs({
  className: "recentgamelist",
})`
  display: flex;
  flex-direction: column;

  > div:nth-child(even) {
    background-color: #f5f5f5;
  }
`;
